import './LoadMore.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const renderLoaderBar = (loadedHits, nbHits) => {
  if (loadedHits && nbHits && loadedHits > 0 && nbHits > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "load-more__line"
    }, /*#__PURE__*/React.createElement("div", {
      className: "load-more__line-fill",
      style: {
        width: `${loadedHits / nbHits * 100}%`
      }
    }));
  }
};
const LoadMore = _ref => {
  let {
    buttonLabel,
    onClick,
    nbHits,
    loadedHits,
    viewedNofMLabel,
    icon
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `load-more ${commonLoadMore}`
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-light load-more__p"
  }, viewedNofMLabel.replace('{#loadedHits#}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{#nbHits#}', String(nbHits))), /*#__PURE__*/React.createElement(LoadMoreButton, {
    className: "btn btn-secondary load-more__btn",
    onClick: e => {
      onClick();
      e.preventDefault();
    }
  }, icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "buttonTextLabel"
  }, buttonLabel), /*#__PURE__*/React.createElement("span", null, icon)) : buttonLabel));
};
const commonLoadMore = "cx0sqfq";
const LoadMoreButton = /*#__PURE__*/styled("button")({
  name: "LoadMoreButton",
  class: "l8vubv7"
});
export default LoadMore;